/** CSS files shared across all detached Tilda pages. Vendored under static/tilda/;
  * nothing here reaches the Tilda API, which the site no longer uses. */
export const TILDA_CSS_FILES = [
  "/tilda/tilda-grid-3.0.min.css",
  "/tilda/tilda-blocks-2.14.css",
  "/tilda/tilda-animation-1.0.min.css",
  "/tilda/tilda-slds-1.4.min.css",
  "/tilda/tilda-zoom-2.0.min.css",
  "/tilda/tilda-menusub-1.0.min.css",
  "/tilda/tooltipster.min.css",
  "/tilda/tilda-cover-1.0.min.css",
  "/tilda/tilda-menu-widgeticons-1.0.min.css",
  "/tilda/tilda-carousel-1.0.min.css",
];
